import { ApiChartAttribute, ApiDimension } from "@incendium/api";
import { Box, DrawerProps, Typography } from "@mui/material";
import StyledDrawer, { StyledDrawerTitle } from "Components/UI/StyledDrawer";
import DimensionSelector from "features/analytics/components/DimensionSelector";
import {
  AccordianChartBuilderSidebarBlock,
  ChartBuilderAttributes,
} from "features/chartLibrary";
import { CallbackOrVal } from "Interfaces";
import { useEffect, useState } from "react";
import { usePrevious } from "react-use";

interface IDimensionExplorerDrawerProps extends DrawerProps {
  dimension: ApiDimension | null;
  setDimension: (v: CallbackOrVal<ApiDimension | null>) => void;
  attributes: ApiChartAttribute[];
  setAttributes: (v: CallbackOrVal<ApiChartAttribute[]>) => void;
}

function DimensionExplorerDrawer({
  open,
  onClose,
  dimension,
  setDimension,
  attributes,
  setAttributes,
}: IDimensionExplorerDrawerProps) {
  const [internalDimension, setInternalDimension] = useState(dimension);
  const [internalAttributes, setInternalAttributes] = useState(attributes);
  const prevOpen = usePrevious(open);

  useEffect(() => {
    if (Boolean(open) && !Boolean(prevOpen)) {
      setInternalDimension(dimension);
      setInternalAttributes(attributes);
    }

    if (!Boolean(open) && Boolean(prevOpen)) {
      setDimension(internalDimension);
      setAttributes(internalAttributes);
    }
  }, [
    open,
    internalDimension,
    internalAttributes,
    setDimension,
    setAttributes,
    prevOpen,
    dimension,
    attributes,
  ]);

  return (
    <StyledDrawer anchor="right" open={open} onClose={onClose}>
      <StyledDrawerTitle>
        <Typography variant="subtitle1">Dimension Explorer Configuration</Typography>
        <Typography variant="body2">Adjust Settings to deep dive.</Typography>
      </StyledDrawerTitle>

      <AccordianChartBuilderSidebarBlock
        title={"Which Dimension are you exploring?"}
      >
        <Box mb={1}>
          <DimensionSelector
            dimension={internalDimension}
            onChange={(e, v) => {
              setInternalDimension(v?.dimension as ApiDimension);
            }}
            fullWidth
          />
        </Box>
      </AccordianChartBuilderSidebarBlock>

      <ChartBuilderAttributes
        title="Explorer Filters"
        subTitle="Select Filters to drill down further into your selected dimension"
        attributes={internalAttributes || []}
        setAttributes={(input) => {
          setInternalAttributes((input || []) as ApiChartAttribute[]);
        }}
      />
    </StyledDrawer>
  );
}

export default DimensionExplorerDrawer;

